import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { SUPPORT_EMAIL } from '../../config';

interface INeedHelpProps {
  className?: string;
  email?: string;
  code?: string;
}

const NeedHelp: React.FC<React.PropsWithChildren<React.PropsWithChildren<INeedHelpProps>>> = ({
  className,
  email = SUPPORT_EMAIL,
  code,
}) => {
  return (
    <div
      className={classNames(
        className,
        'px-5 lg:px-8 py-12 bg-[#EEEFEA] text-center'
      )}
    >
      <h2 className="mb-3 text-2xl leading-tight lg:text-4xl">Need Help?</h2>
      <p className="mb-2 text-gray-5E">
        You can contact Flayr using any of the links below and we'd be glad to
        help.
      </p>
      <div className="mb-6 text-xs lg:mb-10 text-gray-6B">
        Offer Code: {code}
      </div>

      <div className="mb-5 text-lg leading-tight">Contact Us</div>
      <a
        href={`mailto:${email}?subject=Help with search ${code}`}
        className="mx-auto"
        target="__blank"
      >
        <div className="grid w-12 h-12 mx-auto text-2xl bg-white rounded-full place-items-center text-primary">
          <FontAwesomeIcon icon={faEnvelope} />
        </div>
      </a>
    </div>
  );
};

export default NeedHelp;
